module.exports = __webpack_public_path__ + "static/mailbox-f0ed308785aa742087595554398a946d.jpg";